import React, { FC, MutableRefObject, ReactElement } from 'react';
import classNames from 'classnames';

import { JourneyMenu } from 'src/common/JourneyMenu';
import { Step } from 'src/common/interfaces/step.interface';
import { useEditorContext } from 'src/store/editor';
import { useEditorNavigator } from '../use-editor-navigator.hook';
import { EditRegularIcon, SyncRegularIcon } from 'src/monet/icons';
import { EventBus } from 'src/common/EventBus';

interface ContentAddOptionsProps {
  renderOrigin: () => ReactElement;
  openRef: MutableRefObject<() => void>;
  closeRef: MutableRefObject<() => void>;
  onOpen?: () => void;
  onClose?: () => void;
  step: Step;
}

export const ContentAddOptions: FC<ContentAddOptionsProps> = ({
  renderOrigin,
  openRef,
  closeRef,
  onOpen,
  onClose,
  step,
}) => {
  const { setShowSyncedSteps, setCurrentStep } = useEditorContext();
  const { navigateToContentNew } = useEditorNavigator();
  const menuItemClasses = classNames('text-bedrock-p text-bedrock-black flex items-center space-x-sm');

  const onAddSyncedStepClick = () => {
    setCurrentStep(step);
    setShowSyncedSteps(true);
  };

  const onAddNewStepClick = () => {
    setCurrentStep(step);
    EventBus.emit('editor:reset-stage', { resetEditor: true, showInitialStage: true });
    navigateToContentNew(step.id);
  };

  return (
    <JourneyMenu
      placement='top'
      offset={[40, 8]}
      positioningStrategy='fixed'
      openRef={openRef}
      closeRef={closeRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      <JourneyMenu.Item className={menuItemClasses} onClick={onAddNewStepClick}>
        <EditRegularIcon />
        <span>Create new Step</span>
      </JourneyMenu.Item>
      <JourneyMenu.Item className={menuItemClasses} onClick={onAddSyncedStepClick}>
        <SyncRegularIcon />
        <span>Use a Synced Step</span>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
